import { PaymentOptionsVm } from '../classes/paymentOptions';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';

export class PaymentSettingsApi {
  public async getCards(): Promise<PaymentOptionsVm> {
    const response: AxiosResponse<
      AppResponse<PaymentOptionsVm>
    > = await AuthorizedApiClient.get('/payment/GetUserCards');

    const appResponse: AppResponse<PaymentOptionsVm> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async getDefaultCard(): Promise<string> {
    const response: AxiosResponse<
      AppResponse<string>
    > = await AuthorizedApiClient.get('/payment/GetUserDefaultCard');

    const appResponse: AppResponse<string> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async deleteCard(cardId: string): Promise<boolean> {
    const response: AxiosResponse<
      AppResponse<boolean>
    > = await AuthorizedApiClient.post('/payment/DeleteUserCard',
    {
      cardId,
    });

    const appResponse: AppResponse<boolean> = response.data;
    if (appResponse.IsSuccess) {
        return appResponse.Result;
    } else {
        throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async setCardAsDefault(cardId: string): Promise<boolean> {
    const response: AxiosResponse<
      AppResponse<boolean>
    > = await AuthorizedApiClient.post('/payment/SetCardAsDefault',
    {
      cardId,
    });

    const appResponse: AppResponse<boolean> = response.data;
    if (appResponse.IsSuccess) {
        return appResponse.Result;
    } else {
        throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async addNewCard(token: string): Promise<boolean> {
    const response: AxiosResponse<
      AppResponse<boolean>
    > = await AuthorizedApiClient.post('/payment/AddNewCard',
    {
      token,
    });

    const appResponse: AppResponse<boolean> = response.data;
    if (appResponse.IsSuccess) {
        return appResponse.Result;
    } else {
        throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async checkIfUserHasActivePaidSub(): Promise<boolean> {
    const response: AxiosResponse<
      AppResponse<boolean>
    > = await AuthorizedApiClient.get('/account/CheckIfUserHasActivePaidSubscription');

    const appResponse: AppResponse<boolean> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
